import { createSlice } from '@reduxjs/toolkit';
import type { ITSOPageState } from '../data/interfaces/itsomodels';
import { EditorType } from '../data/interfaces/sharedmodels';


// Define the initial state using that type
const initialState: ITSOPageState = {
  selectedDataTable: null,
  selectedNlcs: [],
  selectedOutputNlcs: [],
  selectedOutputTable: null,
  datatableExpanded: false,
  outputtableExpanded: false,
  buildTableStep: 0,
  selectedOutputTables: [],
  currentJobNumber: null,
  jobDescription: null,
  selectedVersion: null,
  filterAttributes: null,
  editorType:EditorType.Table,
  versionChangedCounter:0
}
export const itsoSlice = createSlice({
  name: 'itso',
  initialState,
  reducers: {
    reset: () => initialState,
    updateselectedtable: (state, action) => {
      state.selectedDataTable = action.payload;
    },
    updateselectedNlcs: (state, action) => {
      state.selectedNlcs = action.payload;
    },
    updateselectedoutputtable: (state, action) => {
      state.selectedOutputTable = action.payload;
    },
    updateDatatableExpanded: (state, action) => {
      state.datatableExpanded = action.payload;
    },
    updateOutputtableExpanded: (state, action) => {
      state.outputtableExpanded = action.payload;
    },
    updateselectedOutputNlcs: (state, action) => {
      state.selectedOutputNlcs = action.payload;
    },
    updateBuildTableStep: (state, action) => {
      state.buildTableStep = action.payload;
    },
    updateselectedoutputtables: (state, action) => {
      state.selectedOutputTables = action.payload;
    },
    updateCurrentJobNumber: (state, action) => {
      state.currentJobNumber = action.payload
    },
    updateJobDescription: (state, action) => {
      state.jobDescription = action.payload;
    },
    updateVersion: (state, action) => {
      state.versionChangedCounter++;
      state.selectedVersion = action.payload;
    },
    updateFilterAtts:(state,action)=>{
      state.filterAttributes=action.payload;
    },
    updateEditorType:(state,action)=>{
      state.editorType=action.payload;
    }
  },
});

export const { reset, updateselectedtable, updateselectedNlcs, updateselectedoutputtable, updateselectedoutputtables,
  updateDatatableExpanded, updateOutputtableExpanded, updateselectedOutputNlcs, updateBuildTableStep,
  updateCurrentJobNumber, updateJobDescription, updateVersion,updateFilterAtts,updateEditorType } = itsoSlice.actions

export default itsoSlice.reducer